import { Link, useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles as allArticles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const activeCat = slug || 'plot-analysis';

  const currentCategory = categories.find((c) => c.slug === activeCat);
  const currentArticles = allArticles.filter(
    (a) => a.categorySlug === activeCat
  );

  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "url": `https://cnyangji.cn/category/${activeCat}`,
    "name": `${currentCategory?.name || '分类'} - 色戒完整指南`,
    "description": currentCategory?.description || '',
    "inLanguage": "zh-CN",
  };

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "https://cnyangji.cn/",
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": currentCategory?.name || '分类',
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50 pt-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}></script>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Breadcrumb */}
        <div className="py-4">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: currentCategory?.name || '分类' },
            ]}
          />
        </div>

        {/* Category Header */}
        <section className="py-6">
          <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            {currentCategory?.name}
          </h1>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl">
            {currentCategory?.description}
          </p>
        </section>

        {/* Category Tabs */}
        <div className="flex items-center gap-2 overflow-x-auto pb-4 border-b border-background-200/70 mb-8">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeCat === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-xs`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        {/* Articles Grid */}
        <section className="pb-14">
          {currentArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {currentArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-4xl text-foreground-300 mb-3"></i>
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}